import React from "react";

import Radio from "@cayuse/shared-react.components.form.inputs.radio";

import LabelledComponent from "components/BudgetBuilder/Setup/LabelledComponent";

import styles from "./styles.css";

const CurrencyFormatSelector = ({ editable, displayCents, onChange }) => {
	const handleChange = () => onChange(!displayCents);

	return (
		<LabelledComponent label={"Currency Format"}>
			<div className={styles.radioContainer}>
				<Radio id={"displayCents"} checked={displayCents} disabled={!editable} onChange={handleChange}>
					{"Display cents in all fields"}
				</Radio>
				<Radio id={"doNotDisplayCents"} checked={!displayCents} disabled={!editable} onChange={handleChange}>
					{"Do not display cents in all fields"}
				</Radio>
			</div>
		</LabelledComponent>
	);
};

export default CurrencyFormatSelector;
